import React from "react";
import { IMaskInput } from "react-imask";

interface MaskedInputProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
    mask?: string;
    definitions?: {
        [key: string]: any
    }
}

export const MaskedInput = React.forwardRef<HTMLInputElement, MaskedInputProps>(
    function TextMaskCustom(props, ref) {
        const { onChange, ...other } = props;
        return (
            <IMaskInput
                {...other}
                mask={props.mask}
                definitions={props.definitions}
                inputRef={ref}
                onAccept={(value: any, ref, event) => {
                    if(!event) return // only run change events if entered by user, event is null if not entered by user
                    onChange({ target: { name: props.name, value } })
                }}
                overwrite
            />
        );
    },
);